import { render, staticRenderFns } from "./KintaiCardWeekday.vue?vue&type=template&id=68e64597&"
import script from "./KintaiCardWeekday.vue?vue&type=script&lang=ts&"
export * from "./KintaiCardWeekday.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiCardWeekday.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports